import util from '@bmp-vue/core/api/util'
import theme from '../plugins/theme'
import Axios from 'axios'
import ws from '../../_core/plugins/websocketService'

const controller = 'Dbs'
const getToken = () => JSON.parse(localStorage.getItem('user'))?.token;
const url = process.env.VUE_APP_ROOT_API + controller

export default Object.assign({}, util.GetCrud(controller, ['none']), {
  passos: [
    {
      id: 0,
      img: `..${theme.passo1}`,
      titulo: 'Simule e encontre a proposta ideal para você',
      text: 'Com o crédito aprovado, você escolhe o valor, o prazo e a data de vencimento que caibam no seu planejamento financeiro.'
    },
    {
      id: 1,
      img: `..${theme.passo2}`,
      titulo: 'Confirme as informações',
      text: 'Revise ou solicite a alteração dos dados cadastrais de representantes legais, avalistas e cônjuges anuentes e envie o contrato a todos de maneira automática.'
    },
    {
      id: 2,
      img: `..${theme.passo3}`,
      titulo: 'Assine e receba o seu {produto}',
      text: 'Acompanhe em tempo real o status das assinaturas. E depois de concluídas e de tudo formalizado, o dinheiro estará na sua conta!'
    },
    {
      id: 3,
      img: `..${theme.passo4}`,
      titulo: 'Controle total',
      text: 'Acesse todas as informações de seu crédito contratado: parcelas pagas e a vencer.',
      subText: 'Tudo em um único lugar!'
    }
  ],
  passosAssinatura: [
    {
      id: 0,
      img: `..${theme.emailIcon}`,
      titulo: 'Rapidez e praticidade',
      text: 'Os assinantes informados receberão um e-mail contendo o link para acesso ao portal de assinaturas.'
    },
    {
      id: 1,
      img: `..${theme.passo2}`,
      titulo: 'Segurança e controle',
      text: 'No portal de assinaturas você poderá visualizar o(s) documento(s) e efetivar a assinatura utilizando o seu certificado digital.'
    },
    {
      id: 2,
      img: `..${theme.passo1}`,
      titulo: 'Gestão e visibilidade',
      text: 'Nesta tela, você poderá acompanhar o processo de assinatura e reenviar o email contendo o link de acesso ao portal para aqueles que ainda não efetivaram o processo.'
    },
  ],
  tipoPassoAPassoEnum: {
    Contratacao: 1,
    Assinatura: 2
  },
  bulletColor (th) {
    return [
      { status: th.$aux.StatusContratacaoEnum.Disponivel, color: '#0BBBEF' },
      { status: th.$aux.StatusContratacaoEnum.Contratado, color: '#1A1889' },
      { status: th.$aux.StatusContratacaoEnum.AguardandoAssinatura, color: '#FFA800' },
      { status: th.$aux.StatusContratacaoEnum.Liberada, color: '#FFA800' },
      { status: th.$aux.StatusContratacaoEnum.AguardandoAprovacao, color: '#FFA800' },
      { status: null, color: '' },
    ]
  },
  bulletColorAssinatura (th) {
    return [
      { status: th.$aux.StatusAssinantesEnum.AguardandoNotificacao, color: '#FFA800' },
      { status: th.$aux.StatusAssinantesEnum.Recusado, color: '#cc1a10' },
      { status: th.$aux.StatusAssinantesEnum.AguardandoAssinatura, color: '#FFA800' },
      { status: th.$aux.StatusAssinantesEnum.AguardandoAprovacao, color: '#FFA800' },
      { status: th.$aux.StatusAssinantesEnum.Cancelado, color: '#FFA800' },
      { status: th.$aux.StatusAssinantesEnum.Assinado, color: '#30B900' },
      { status: th.$aux.StatusAssinantesEnum.Aprovado, color: '#30B900' },
      { status: th.$aux.StatusAssinantesEnum.CertificadoComSenhaIncorretaOuArquivoCorrompido, color: '#cc1a10' },
      { status: th.$aux.StatusAssinantesEnum.AguardandoFaceMatch, color: '#FFA800' },
      { status: th.$aux.StatusAssinantesEnum.FaceMatchInvalido, color: '#cc1a10' },
      { status: th.$aux.StatusAssinantesEnum.ProcessandoAssinatura, color: '#FFA800' },
      { status: th.$aux.StatusAssinantesEnum.Confirmado, color: '#30B900' },
      { status: th.$aux.StatusAssinantesEnum.Expirado, color: '#FFA800' },
      { status: th.$aux.StatusAssinantesEnum.ErroProcessamento, color: '#FFA800' },
    ]
  },
  textButton: [
    { status: 0, text: 'Simular' },
    { status: 1, text: 'Ver detalhes' },
    { status: 3, text: 'Revisar' },
    { status: 8, text: 'Liberada' },
    { status: 9, text: 'Acompanhar' },
  ],
  GetSituacaoParcela: function (th, status, dtVencimento) {
    let chipContent = {}
    switch (status) {
      case th.$aux.SituacaoParcelaEnum.EmAberto:
      case th.$aux.SituacaoParcelaEnum.AVencer:
      case th.$aux.SituacaoParcelaEnum.Vencido:
        if (th.$api.UI.Date.DaysBetween(new Date(), dtVencimento) >= 0) {
          chipContent = { text: 'A vencer', color: '#E4E7EC', textColor: '#000' }
        } else {
          chipContent = { text: 'Vencida', color: '#F44336', textColor: '#FFF' }
        }
        break;
      case th.$aux.SituacaoParcelaEnum.Pago:
        chipContent = { text: 'Paga', color: '#2926DB', textColor: '#FFF' }
        break;
      case th.$aux.SituacaoParcelaEnum.Cancelado:
        chipContent = { text: 'Cancelada', color: '#E4E7EC', textColor: '#000' }
        break
    };

    return chipContent
  },
  NomeAssinantes: [
    { text: 'Por avalista', value: 1 },
    { text: 'Pela Empresa emitente', value: 2 },
    { text: 'Conjugê anuente', value: 3 }
  ],
  passoAssinante: [
    {
      img: '../assets/imgs/assinatura1.svg',
      titulo: 'Confirme a solicitação',
      text: 'Deseja confirmar a solicitação das alterações dos dados cadastrais?',
    },
    {
      img: '../assets/imgs/assinatura2.svg',
      titulo: 'Solicitação recebida com sucesso!',
      text: 'Seu pedido está em análise e retornaremos em breve.'
    },
    {
      img: '../assets/imgs/assinatura2.svg',
      titulo: 'Alteração realizada com sucesso!',
      text: 'A alteração cadastral foi realizada com sucesso, prossiga com a assinatura.'
    }
  ],
  GetReferenceToken: function (dto) {
    const request = { ReferenceToken: dto.referenceToken, Ambiente: dto.ambiente }

    const headers = { Authorization: `Bearer ${getToken()}` }
    return Axios.post(url + '/GetReferenceToken', request, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleErrorBase)
  },
  async GetDadosDesembolso (th, codigo) {
    const response = await th.$api.Multiplo.FindRecordPropostaContaPagamento({
      guidID: codigo,
    })
    if (!response.error) {
      return response
    } else {
      return {
        Agencia: '1234',
        AgenciaDig: '',
        Conta: '99999',
        ContaDig: '8'
      }
    }
  },
  SituacaoParcela: {
    Aberta: 0,
    Paga: 1,
    Cancelada: 2,
    AVencer: 10,
    Vencida: 11
  },
  ModeloContaEnum: {
    Movimento: 1,
    Escrow: 2,
    Vinculada: 3
  },
  GetDadosBancariosByCorrentista: function (dto) {
    const headers = { Authorization: `Bearer ${getToken()}` }
    return Axios.get(url + `/GetDadosBancariosByCorrentista/${dto.DocumentoFederal}`, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
  },
  DadosLimite: {
    img: 'not-found-icon',
    title: 'O cliente não possui limite de crédito disponível.',
  },
  acaoAssinante: [
    {
      titulo: 'Atenção ao reenviar o contrato para assinatura',
      text: 'Aguarde 5 minutos para reenviar a solicitação.',
      subText: 'Caso não tenha recebido após esse período, solicite o reenvio ou entre em contato com os nossos canais de atendimento.'
    },
    {
      titulo: 'Sua solicitação possui pendências',
      text: 'Entre em contato com os nossos canais de atendimento para dar continuidade à contratação de crédito.'
    },
  ],
  SituacaoEnvelopeEnum: {
    Aguardando: 0,
    ErroGeracao: 1,
    ErroPublicacao: 2,
    Sucesso: 3
  },
  ValidacaoRetornoTAC (th, valor, tipoCalculo, valorTac) {
    if (tipoCalculo === th.$aux.TipoCalculoTacEnum.Porcentagem) {
      const resultado = valor * (valorTac / 100);
      return resultado;
    }
    return valorTac;
  },
  ParcelaCustomizada (customizacao) {
    const periodoPlanilha = customizacao.find((item) => (item.NomeCampo === 'APIQtdeParcelas'))?.ValorCampo.split('_').map(Number)
    if (periodoPlanilha && periodoPlanilha[0]) {
      return periodoPlanilha
    }
    return null
  },
  SavePropostaCampoAuxiliar (th, nomeCampo, valorCampo) {
    const campos = []
    campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: nomeCampo, ValorCampo: valorCampo })
    return th.$api.Multiplo.SavePropostaCampoAuxiliar({ dto: campos })
  },
  CarregarDadosIniciais (dto) {
    const headers = { Authorization: `Bearer ${getToken()}` }
    return Axios.post(url + '/CarregarDadosIniciais', dto, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleErrorBase)
  },
  ListPropostaCliente (dto) {
    const headers = { Authorization: `Bearer ${getToken()}` }
    util.store.commit('addRequest')
    return Axios.post(url + '/ListPropostaCliente', dto, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleErrorBase)
  },
  IncluirPropostaManual (dto) {
    const request = { Dto: dto }
    const headers = { Authorization: `Bearer ${getToken()}` }
    util.store.commit('addRequest')
    return Axios.post(url + '/IncluirPropostaManual', request, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleErrorBase)
  },
  ConnectWebsocket (grupo) {
    ws.connect(getToken(), () => {
      this.JoinGroup(grupo)
    })
  },
  JoinGroup (grupo) {
    ws.joinGroup(grupo)
  },
  SubscribeWS (callback) {
    ws.subscribe(msg => {
      if (msg === 'Proposta Atualizada') {
        try {
          callback()
        } catch (ex) {
          // console.log('erro', ex)
        }
      }
    })
  },
  UnsubscribeWS (callback) {
    ws.unsubscribe(callback)
  }
})
